import { Body2, Box, Label2 } from '@csp/csp-web-ui';
import { FC } from 'react';
import { StaticContentService } from '../../../common/service/StaticContentService';

export const OpeningHours: FC = () => {
  const openingHoursContent = StaticContentService.getGenericBlock('webHcpTechnicalSupport', 'openingHours');

  return (
    <Box mb={7}>
      <Label2 color="textSecondary" fontWeight={700} mb={1}>
        {openingHoursContent.textLabel.label}
      </Label2>
      <Body2>{openingHoursContent.body.text}</Body2>
    </Box>
  );
};
